<template>
    <div>
        <embed v-if="fileUrl" :src="fileUrl" width="800px" height="2100px" />
    </div>
</template>

<script>
    import AuthService from 'services/AuthService'

    export default {
        data() {
            return {
                fileUrl: null,
            }
        },

        methods: {
            getFile() {
                const url = this.$route.query.url
                fetch(url, {
                    responseType: 'blob',
                    headers: new Headers({
                        Authorization: `Bearer ${AuthService.getToken()}`,
                    }),
                })
                    .then((response) => response.blob())
                    .then((blob) => {
                        this.fileUrl = window.URL.createObjectURL(blob)
                    })
            },
        },

        mounted() {
            this.getFile()
        },
    }
</script>
